import { useCallback } from "react";
import { useResizeObserver } from "hooks/useResizeObserver";
import { Text, TextProps } from "./Text";
import { getNumberRoundedToPrecision } from "../../../../helpers";
import { Size } from "../../../../types";

interface TextWithResizeObserverProps extends TextProps {
  currentHeight: number; //in pixels
  onResize: (heightInPixels: number) => void;
}
export const TextWithResizeObserver = ({
  currentHeight,
  onResize,
  ...props
}: TextWithResizeObserverProps) => {
  const handleResize = useCallback(
    (size: Size) => {
      // Don't call onResize if currentHeight is 0 (meaning height was null)
      // This prevents setting height when it should remain null
      if (currentHeight === 0) return;

      const areEqual =
        getNumberRoundedToPrecision(size.height, 2) ===
        getNumberRoundedToPrecision(currentHeight, 2);
      if (areEqual) return;
      onResize(size.height);
    },
    [currentHeight, onResize]
  );

  const fontPreviewRef = useResizeObserver(handleResize);

  return (
    <div ref={fontPreviewRef}>
      <Text {...props} />
    </div>
  );
};
